var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrderModifyArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  d: "M15.854 1h-10.5a1 1 0 0 0-1 1v11.793L7 11.147l.707.707-3.853 3.853L0 11.853l.707-.707 2.647 2.647V2A2 2 0 0 1 5.149.01L5.354 0h10.5z"
})));
export default SvgOrderModifyArrow;